<ng-template
  #radioItemRoundTemplate
  let-value="value"
  let-disabled="disabled"
  let-id="id"
  let-labelText="labelText"
  let-label="label"
  let-first="first"
  let-last="last"
>
  <label
    [attr.data-testid]="value"
    [class]="'ps-xxsmall-y radio-item ' + theme"
    [ngClass]="{
      'first-radio': first,
      'last-radio': last,
      'center-radio': !first && !last,
      'ms-xxsmall-t': !first && !isHorizontal,
    }"
    [formGroup]="parentForm"
    [attr.aria-checked]="parentForm.value[controlName] === value"
    [class.disabled]="control.disabled || disabled"
    [class.error]="control.invalid && control.touched"
    [class.checked]="parentForm.value[controlName] === value"
  >
    <div class="flex relative regular-type radio-wrapper" [class.grey-600-text]="control.disabled || disabled">
      <input
        class="is-vishidden"
        role="radio"
        [class.sensitive]="isSensitive"
        [id]="id"
        type="radio"
        [attr.name]="name || controlName"
        [value]="value"
        [formControlName]="controlName"
        [name]="controlName"
        [attr.disabled]="disabled ? 'disabled' : null"
      />
      <span aria-hidden="true">
        @if (parentForm.value[controlName] === value) {
          <fcom-icon
            class="radio-icon icon-medium"
            [dataTestId]="'icon-' + SvgLibraryIcon.RADIO_SELECTED"
            [name]="SvgLibraryIcon.RADIO_SELECTED"
          />
        } @else {
          <fcom-icon
            class="radio-icon icon-medium"
            [class.error-900-text]="control.invalid && control.touched"
            [dataTestId]="'icon-' + SvgLibraryIcon.RADIO_UNSELECTED"
            [name]="SvgLibraryIcon.RADIO_UNSELECTED"
          />
        }
      </span>
      <div class="full-width ms-xsmall-l">
        <span class="label font-body-1 medium-type">
          {{ labelText ? labelText : ((label ? label : translationPrefix + '.' + value) | finLocalization) }}
        </span>
      </div>
    </div>
  </label>
</ng-template>

<ng-template
  #radioItemBoxTemplate
  let-value="value"
  let-disabled="disabled"
  let-id="id"
  let-labelText="labelText"
  let-label="label"
  let-first="first"
  let-last="last"
  let-twoItemMode="twoItemMode"
>
  <label
    [attr.data-testid]="value"
    [class]="'radio-item ' + theme"
    [ngClass]="{
      'first-radio': first,
      'last-radio': last,
      'center-radio': !first && !last,
      'two-item-mode': twoItemMode,
      checked: parentForm.value[controlName] === value,
      error: control.invalid && control.touched,
      disabled: control.disabled || disabled,
    }"
    class="flex relative flex--center"
    [formGroup]="parentForm"
    [attr.aria-checked]="parentForm.value[controlName] === value"
  >
    <div class="radio-wrapper relative">
      <div class="flex flex--center regular-type ps-xxlarge-x">
        <input
          class="is-vishidden"
          role="radio"
          [id]="id"
          type="radio"
          [class.sensitive]="isSensitive"
          [attr.name]="name || controlName"
          [value]="value"
          [formControlName]="controlName"
          [name]="controlName"
        />
        <span class="flex flex--middle label font-body-1 medium-type nowrap relative">
          <fcom-icon
            class="icon icon-small"
            [class.active]="parentForm.value[controlName] === value"
            [name]="SvgLibraryIcon.CHECKMARK"
          />
          {{ labelText ? labelText : ((label ? label : translationPrefix + '.' + value) | finLocalization) }}
        </span>
      </div>
    </div>
  </label>
</ng-template>

<div
  [formGroup]="parentForm"
  class="radio-group"
  role="radiogroup"
  [attr.aria-labelledby]="'radio-group-label-' + controlName"
>
  <div
    *ngIf="translationPrefix && titleText"
    [id]="'radio-group-label-' + controlName"
    class="font-body-1 ms-small-b"
    data-testid="radio-item-group-title"
  >
    <span
      [ngClass]="{
        'nordic-blue-400-text': !control.invalid || !control.touched,
        'error-900-text': control.invalid && control.touched,
      }"
    >
      {{ translationPrefix + '.label' | finLocalization }}
      <span *ngIf="isRequired"> *</span>
    </span>
  </div>
  <div
    class="flex"
    [class]="theme"
    [ngClass]="{
      'flex--row': theme === RadioButtonTheme.ROUND && isHorizontal,
      'flex--column': theme === RadioButtonTheme.ROUND && !isHorizontal,
    }"
  >
    <ng-container *ngFor="let option of options; let first = first; let last = last">
      @if (theme === RadioButtonTheme.ROUND) {
        <ng-container
          *ngTemplateOutlet="
            radioItemRoundTemplate;
            context: {
              value: option.value,
              disabled: option.disabled,
              id: id + '-' + option.value,
              labelText: option.labelText,
              label: option.label,
              first: first,
              last: last,
            }
          "
        />
      }

      @if (theme === RadioButtonTheme.BOX) {
        <ng-container
          *ngTemplateOutlet="
            radioItemBoxTemplate;
            context: {
              value: option.value,
              disabled: option.disabled,
              id: id,
              labelText: option.labelText,
              label: option.label,
              first: first,
              last: last,
              twoItemMode: options.length === 2,
            }
          "
        />
      }
    </ng-container>
  </div>

  <div
    *ngIf="translationPrefix && errorText && control.invalid && control.touched"
    class="error-label font-body-2 ps-small-t"
    aria-live="polite"
  >
    <span *ngIf="control.errors?.required" class="error-900-text">
      {{ translationPrefix + '.required' | finLocalization }}
    </span>
  </div>

  <div
    *ngIf="translationPrefix && helperText && !(control.invalid && control.touched)"
    class="helper-label font-body-2 ps-small-t"
  >
    <span class="nordic-blue-400-text">
      {{ translationPrefix + '.helper' | finLocalization }}
    </span>
  </div>
</div>
